export const defaultState = {
  id: null,
  firstName: '',
  lastName: '',
  email: '',
  title: '',
  middleName: '',
  birthDate: null,
  status: null,
};
const SET_EDIT_DATA = 'SET_EDIT_DATA';
const UPDATE_FIELD = 'UPDATE_FIELD';

export const setEditDataCreator = (payload) => ({ type: SET_EDIT_DATA, payload });
export const updateFieldCreator = (payload) => ({ type: UPDATE_FIELD, payload });

export default function (state = defaultState, action) {
  if (action.type === SET_EDIT_DATA) {
    return {
      ...state,
      ...action.payload,
      birthDate: action.payload.birthDate ? new Date(action.payload.birthDate) : undefined,
    };
  }

  if (action.type === UPDATE_FIELD) {
    return { ...state, [action.payload.name]: action.payload.value };
  }

  return state;
}
